module.exports = "<app-createrace></app-createrace>\n<app-list-org></app-list-org>\n<app-list-user></app-list-user>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/nascar/manageraces/manageraces.component.html
// module id = ../../../../../src/app/admin/nascar/manageraces/manageraces.component.html
// module chunks = main